export const ImportTypes = {
  fileSystem: 1,
  excelFiles: 2,
  csvFiles: 3,
  xmlFiles: 4,
  dbSource: 5,
};

export const ImportFileSystemColumns = {
  fileNames: 'filenames',
  paths: 'paths',
  isFolder: 'isFolder',
  fileIndexes: 'fileIndexes',
};

export const ImportNotificationAction = {
  start: 'start',
  processing: 'processing',
  error: 'error',
  finish: 'finish',
  progress: 'progress',
  fileUploaded: 'finish-upload',
};

export const FileFinderOptions = {
  embedded: 'embedded',
  inValue: 'inValue',
  pattern: 'pattern',
};

export const StorageTypes = {
  catalog: 'catalog',
  users: 'users',
  orders: 'orders',
  formData: 'form-data',
};

export const SpecialValuesTypes = {
  productStatuses: 'productStatuses',
  // forms: 'forms',
  // authProviders: 'authProviders',
  orderStatuses: 'orderStatuses',
  paymentAccounts: 'paymentAccounts',
  formDataStatuses: 'formDataStatuses',
};
